import { useState, useEffect, useCallback } from 'react';

/**
 * Cờ "đã nhận phản hồi đầu tiên" cho một widget dashboard.
 *
 * - hasSource = false (widget không khai url) → coi như xong ngay, không treo skeleton.
 * - markLoaded() gọi ở CẢ nhánh thành công lẫn nhánh lỗi/rỗng.
 * - Cờ chỉ bật lên, KHÔNG bao giờ tắt lại → các lượt refresh định kỳ không nháy skeleton.
 * - Chốt an toàn timeoutMs (mặc định 15s): máy chủ không trả thì vẫn bỏ skeleton.
 */
export default function useWidgetFirstLoad(hasSource, timeoutMs) {
    var [loaded, setLoaded] = useState(!hasSource);

    var markLoaded = useCallback(function () {
        setLoaded(true);
    }, []);

    useEffect(
        function () {
            if (loaded) return;
            var ms = timeoutMs || 15000;
            var timer = setTimeout(function () {
                setLoaded(true);
            }, ms);
            return function () {
                clearTimeout(timer);
            };
        },
        [loaded, timeoutMs]
    );

    return [loaded, markLoaded];
}
